<template>
  <div class="container-fluid">
    <div class="block-header">
      <div class="clearfix row">
        <div class="col-md-6 col-sm-12">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a href="#">Master</a></li>
              <li class="breadcrumb-item"><a href="#">Category</a></li>
              <li class="breadcrumb-item active" aria-current="page">Edit Category</li>
            </ol>
          </nav>
        </div>
        <div class="text-right col-md-6 col-sm-12">
          <!-- <router-link
            :to="'/admin/category'"
            class="btn btn-outline-danger"
            title="Go to Category" ><i class="mr-2 fa fa-arrow-circle-left"></i>Back</router-link> -->

          <router-link
            :to="'/admin/category/category_filter' + this.domain_id"
            class="btn btn-outline-danger"
            ><i class="mr-2 fa fa-arrow-circle-left"></i>Back</router-link
          >
        </div>
      </div>
    </div>

    <div class="clearfix row">
      <div class="mx-auto col-md-8">
        <div class="card">
          <div class="card-header bg-primary custom-title theme-backcolor">
            <h6 class="text-white fs">Edit Category</h6>
          </div>
          <!---->
          <v-app class="fixVapp">
            <div class="body">
              <form>
                <!-- <div class="form-group">
                 <v-autocomplete
                  attach
                  label="Select Domain"
                  :items="domains"
                  item-text="domain_title"
                  item-value="domain_id"
                  v-model="selected"
                  outlined
                  dense
                  :error-messages="errors.domain_id"
                ></v-autocomplete>
              </div> -->
                <div class="d-flex mt-n2">
                  <v-col lg="6" md="6" sm="6">
                    <div class="form-group">
                      <label class="text-muted">Category Title</label>
                      <v-text-field
                        label="Category Title"
                        v-model="category_title"
                        type="text"
                        outlined
                        class="mt-n8"
                        dense
                        :error-messages="errors.category_title"
                      />
                    </div>
                  </v-col>
                  <!-- <v-col lg="6" md="6" sm="6">
                    <div class="form-group">
                      <label class="text-muted">Category Icon</label>
                      <v-text-field
                        label=""
                        class="mt-n8"
                        v-model="category_icon"
                        type="text"
                        outlined
                        dense
                      />
                    </div>
                  </v-col> -->
                  <v-col lg="6" md="6" sm="6">
                    <div class="form-group">
                      <label class="text-muted">Category Description</label>
                      <v-text-field
                        type="text"
                        label=""
                        class="mt-n8"
                        v-model="category_description"
                        outlined
                        dense
                        :error-messages="errors.category_description"
                      />
                    </div>
                  </v-col>
                </div>
                <div class="d-flex mt-n8">
                  <v-col lg="6" md="6" sm="6">
                    <div class="form-group">
                      <label class="text-muted">SEO Name</label>
                      <v-text-field
                        type="text"
                        label=""
                        v-model="seo_name"
                        outlined
                        dense
                        class="mt-n8"
                        :error-messages="errors.seo_name"
                      />
                    </div>
                  </v-col>

                  <v-col lg="6" md="6" sm="6">
                    <div class="form-group">
                      <label class="text-muted">Global Faq</label>
                      <!-- <label for="">Global Faq</label> -->
                      <v-autocomplete
                        label=""
                        item-text="name"
                        item-value="id"
                        :items="global_faq_items"
                        class="mt-n8"
                        v-model="global_faq"
                        outlined
                        dense
                        :error-messages="errors.global_faq"
                      />
                    </div>
                  </v-col>
                </div>
                <div class="d-flex mt-n8">
                  <v-col lg="6" md="6" sm="6">
                    <div class="form-group">
                      <label class="text-muted">Order</label>
                      <v-text-field
                        label=""
                        v-model="order"
                        type="number"
                        class="mt-n8"
                        outlined
                        dense
                        :error-messages="errors.order"
                      />
                    </div>
                  </v-col>

                  <v-col lg="6" md="6" sm="6">
                    <div class="form-group">
                      <label class="text-muted">SAC (Optional)</label>
                      <v-text-field
                        type="text"
                        label=""
                        class="mt-n8"
                        v-model="sac"
                        outlined
                        dense
                        :error-messages="errors.sac"
                      />
                    </div>
                  </v-col>
                </div>

                <!-- <div class="d-flex mt-n8"> -->

                <!-- <v-col lg="6" md="6" sm="6">
                    <div class="form-group">
                      <label class="text-muted">Image</label>
                      <v-file-input
                        :error-messages="errors.image"
                        dense
                        outlined
                        class="mt-n8"
                        v-model="imageCategory"
                        accept="image/png, image/jpeg, image/webp, image/bmp"
                        placeholder="Pick an image"
                        prepend-icon="mdi-camera"
                        label=""
                      ></v-file-input>
                    </div>
                  </v-col> -->
                <!-- </div> -->
                <!-- <div class="form-group">
               <v-radio-group v-model="category_featured" row>
                  <span>Category Featured  </span>
                  <v-radio label="Yes" name="category_featured" value="Y" @change="categoryFeatureChecked($event)" :error-messages="errors.category_featured"></v-radio>
                  <v-radio label="No" name="category_featured" value="N" @change="categoryFeatureChecked($event)" :error-messages="errors.category_featured"></v-radio>
                </v-radio-group>
              </div> -->
                <div class="mx-auto col-md-3 mt-n3">
                  <button
                    type="button"
                    class="text-white theme-backcolor btn btn-primary"
                    @click="CategoryUpdate"
                  >
                    <i class="mr-2 fa fa-save"></i>Update
                  </button>
                </div>
              </form>
            </div>
            <v-overlay :value="isLoading">
              <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
          </v-app>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataService from '../../../dataservice';
export default {
  components: {},
  data() {
    return {
      errors: '',
      domains: [],
      global_faq_items: [],
      global_faq: '',
      selected: null,
      category_title: '',
      category_icon: '',
      imageCategory: '',
      category_description: '',
      seo_name: '',
      sac: '',
      order: '',
      domain_id: null,
      category_isactive: 'Y',
      Isactive: null,
      isLoading: false,
      // category_featured :'',
    };
  },
  methods: {
    getCategory(id) {
      this.isLoading = true;
      DataService.getCategoryById(id).then(response => {
        this.category_id = response.data.category_id;
        this.category_title = response.data.category_title;
        this.category_icon = response.data.category_icon;
        this.category_description = response.data.category_description;
        this.seo_name = response.data.seoname;
        this.sac = response.data.sac;
        this.category_isactive = response.data.category_isactive;
        this.domain_id = response.data.domain_id;
        this.global_faq = response.data.global_faq_id;
        this.order = response.data.order;
        this.isLoading = false;
        // this.domain_title = response.data.domain_title
        //this.category_featured  = response.data.category_featured;

        // setting here domain Id for drop down selected value
        // this.selected = response.data.domain_id;
      });
    },
    //categoryFeatureChecked(e) {
    //   this.category_featured = e.target.value;
    // },
    CategoryUpdate() {
      const data = new FormData();
      data.append('category_title', this.category_title);
      data.append('category_icon', this.category_icon);
      data.append('category_description', this.category_description);
      data.append('seo_name', this.seo_name);
      // data.append("domain_id",this.selected);
      // data.append("category_featured", this.category_featured);
      data.append('category_isactive', this.category_isactive);
      data.append('image', this.imageCategory);
      data.append('global_faq', this.global_faq);
      data.append('order', this.order);
      data.append('sac', this.sac);
      DataService.updateCategory(this.category_id, data)
        .then(response => {
          this.s('Category', 'Record Updated successfully');
          this.$router.push({
            name: 'CategoryFilter',
            params: { id: this.domain_id },
          });
        })
        .catch(error => {
          this.errors = error.response.data.error;
          this.e("Oop's", 'Something went wrong.');
        });
    },
    getGlobalFaq() {
      DataService.globleFaqMasterGet()
        .then(response => {
          this.global_faq_items = response.data;
        })
        .catch(error => {});
    },
  },
  created() {
    this.getGlobalFaq();
    DataService.getAllDomain()
      .then(response => {
        this.domains = response.data;
      })
      .catch(e => {
        // console.log(e);
      });
    this.getCategory(this.$route.params.id);
  },
};
</script>
<style scoped>
.fixVapp {
  height: 100px;
}
.custom-title {
  padding: 12px 20px !important;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.fs {
  font-size: 18px !important;
  font-weight: 600 !important;
}
</style>
